import { useColorPickerClipboard } from "client/hooks/utils/useColorpickerClipboard";
import { selectText } from "client/utils/selectText";
import { useRef } from "react";
import { ColorCardProps } from "./ColorCard";

export const useColorCard = ({ hex, source }: ColorCardProps) => {
    const { isCopied, handleCopy } = useColorPickerClipboard(source);
    const hexRef = useRef<HTMLDivElement>(null);
    function handleClick() {
        handleCopy(hex);
        hexRef.current && selectText(hexRef.current);
    }
    return {
        isCopied,
        handleClick,
        hexRef,
    };
};
